/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LaundryUserReference
 */
export interface LaundryUserReference {
    /**
     * 
     * @type {string}
     * @memberof LaundryUserReference
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LaundryUserReference
     */
    readonly firstName: string;
    /**
     * 
     * @type {string}
     * @memberof LaundryUserReference
     */
    readonly lastName: string;
    /**
     * 
     * @type {string}
     * @memberof LaundryUserReference
     */
    readonly email?: string;
}

/**
 * Check if a given object implements the LaundryUserReference interface.
 */
export function instanceOfLaundryUserReference(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;

    return isInstance;
}

export function LaundryUserReferenceFromJSON(json: any): LaundryUserReference {
    return LaundryUserReferenceFromJSONTyped(json, false);
}

export function LaundryUserReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LaundryUserReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': !exists(json, 'email') ? undefined : json['email'],
    };
}

export function LaundryUserReferenceToJSON(value?: LaundryUserReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

